import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {useContactListurl} from "./contactsTable.constants";

export const useContactsSearchOptions = () => {
  const contactListurl = useContactListurl();
  const options = useSearchOptions(contactListurl, [
    "phone",
    "email",
    "first_name",
    "last_name",
  ]);

  const searchOptions = [
    {
      category: {label: "First Name", value: "first_name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.first_name,
    },
    {
      category: {label: "Last Name", value: "last_name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.last_name,
    },
    {
      category: {label: "Phone", value: "phone"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.phone,
    },
    {
      category: {label: "Email", value: "email"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.email,
    },
  ];

  return {searchOptions};
};
